<script>
    import {onMount} from 'svelte';
    import Loader from "../components/Loader.svelte";

    export let params;

    let content = '<h4 class="text-center">Loading...</h4>';
    let loading;
    $: params && loadDocument();

    onMount(() => loadDocument());

    async function loadDocument() {
        loading = true
        const response = await fetch('/help-files/' + params.section + '.html');
        content = await response.text();
        loading = false;
    }
</script>
<main class="container pt-5">
    {#if loading}
        <Loader></Loader>
    {:else}
        {#if content.indexOf('<!--DEFAULT_PAGE-->') < 0}
            {@html content}
        {:else}
            <div class="text-center text-danger">
                <h1>SECTION NOT FOUND!</h1>
            </div>
        {/if}
    {/if}
    <div class="text-center">
        <a href="/">Back</a>
    </div>
</main>
